import checkIfUrlHasSameDomain from './check-if-url-has-same-domain';
import sanitizeUrlForExternalLink from './sanitize-url-for-external-link';
import hasRelationship from './has-relationship';
import isAbsolutePath from './is-absolute-path';
import shouldUseStandardAnchor from './should-use-standard-anchor';

export {
  checkIfUrlHasSameDomain,
  sanitizeUrlForExternalLink,
  hasRelationship,
  isAbsolutePath,
  shouldUseStandardAnchor
};
